import { auth } from "apis";

export const getAllCoupons = async (page) => {
    const res = await auth({
        method: "GET",
        url: `/admin/coupons?page=${page}&limit=10`,
    });
    return res;
}

export const getCouponUsedUsersListByCouponId = async (id,page) => {
    const res = await auth({
        method: "GET",
        url: `/admin/coupons/${id}?page=${page}&limit=10`,
    });
    return res;
}
export const updateCoupon = async (id, data) => {
    const res = await auth({
        method: "PUT",
        url: `/admin/coupon/${id}`,
        data
    });
    return res;
}
export const createCoupon = async (data) => {
    const res = await auth({
        method: "POST",
        url: `/admin/coupon`,
        data
    });
    return res;
}